import React, {FC} from "react"
import {Row} from "react-bootstrap"

import {FormattedMessage} from "@irati/utils/lang"
import {H4, Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import Slider from "@irati/ui/src/Slider"
import {SETTINGS_REGULAR} from "../FeedSlider"

import {NoDealsWrapper, NoDealsEmptyImage, NoDealsText} from "./styled"

interface Props {
  updateLinkClick: () => void
}

const NoDealsInCategory: FC<Props> = ({updateLinkClick}) => {
  return (
    <Row>
      <Slider settings={SETTINGS_REGULAR}>
        <NoDealsWrapper>
          <NoDealsEmptyImage />
          <NoDealsText>
            <H4 marginBottom={1}>
              <FormattedMessage id="perks.containers.customisation.nocontent.header" />
            </H4>
            <Body small>
              <FormattedMessage
                id="perks.containers.customisation.nocontent.body"
                values={{
                  link: (
                    <Button tertiary cta onClick={updateLinkClick}>
                      <FormattedMessage id="perks.containers.customisation.nocontent.link" />
                    </Button>
                  )
                }} />
            </Body>
          </NoDealsText>
        </NoDealsWrapper>
      </Slider>
    </Row>
  )
}

export default NoDealsInCategory
